import { Component, OnInit } from "@angular/core";
import { CommonService } from "../services/common.service";
import { appConstants } from "../constants/appConstants";
import { environment } from "src/environments/environment";
import { dataConstants } from "../constants/dataConstants";
import { validateHorizontalPosition } from "@angular/cdk/overlay";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-payement-blocker",
  templateUrl: "./payement-blocker.component.html",
  styleUrls: ["./payement-blocker.component.scss"],
})
export class PayementBlockerComponent implements OnInit {
  pageSize: number = 10;
  page: number = 0;
  submitted: boolean = false;
  payment_bolcker_data: Array<any> = [];
  sourceType: Array<string> = dataConstants.userType;
  statusType: Array<boolean> = dataConstants.status;
  uploadfile: any = "";
  pageLimit: number[] = [5, 10, 25, 50, 100];
  search = {
    phone: "",
    source: "",
    status: "",
  };
  userdata = {
    phone: "",
    name: "",
    source: "",
    status: "",
  };
  isaddnewUser: boolean = false;
  isEditable: number = null;
  constructor(
    private _commonService: CommonService,
    private _toasterService: ToastrService
  ) {}

  ngOnInit() {
    this.getPaymentBlocker(this.page);
  }
  getPaymentBlocker(pageNo) {
    let url =
      appConstants.PAYMENT_BLOCKER +
      `?pageNo=${pageNo}&pageSize=${this.pageSize}&phones=${this.search.phone}&source=${this.search.source}&status=${this.search.status}`;
    this._commonService.getRequest(url).subscribe(
      (res) => {
        this.payment_bolcker_data = res;
      },
      (err) => {
        console.log("err", err);
      }
    );
  }
  onFileChange(file) {
    this.uploadfile = file.item(0);
  }
  Uploadcsvdata() {
    if (this.uploadfile) {
      let url = appConstants.PAYMENT_BLOCKER + "/upload";

      this._commonService.postFile(this.uploadfile, url).subscribe((res) => {
        console.log("res", res);
      });
    } else {
      this._toasterService.warning("Please upload file then click on button");
    }
  }
  downloadcsvfile() {
    let url = environment.base_url + appConstants.PAYMENT_BLOCKER + "/download";
    window.open(url);
  }
  postData(url, data) {
    this._commonService.PostRequest(data, url).subscribe(
      (res) => {
        if (res) {
          this.isaddnewUser = false;
          this._toasterService.success(
            "Custom Video Config Share Update successfully",
            "Success",
            { timeOut: 1000 }
          );
          this.getPaymentBlocker(this.page);
        }
      },
      (err) => {
        this._toasterService.warning(err.error.message);
        console.log(err);
      }
    );
  }
  AddnewUser() {
    this.isaddnewUser = true;
  }
  editableData(index) {
    this.isEditable = index;
  }
  isValid(data) {
    let value = Object.values(data).every((val) => val !== "");
    return value;
  }
  updateData(data) {
    this.submitted = true;

    if (this.isValid(data)) {
      let url = appConstants.PAYMENT_BLOCKER;
      this.isEditable = null;
      this.postData(url, data);
    }
  }
  submit() {
    this.submitted = true;
    if (this.isValid(this.userdata)) {
      let url = appConstants.PAYMENT_BLOCKER;
      this.postData(url, this.userdata);
    }
  }
  previousPage() {
    if (this.page > 0) {
      this.page = this.page - 1;
      this.getPaymentBlocker(this.page);
    }
  }

  nextPage() {
    if (
      this.payment_bolcker_data &&
      this.payment_bolcker_data.length == this.pageSize
    ) {
      this.page = this.page + 1;
      this.getPaymentBlocker(this.page);
    }
  }
  navigateTo(pageNo: number) {
    this.getPaymentBlocker(pageNo);
  }
  changePageSize() {
    this.page = 0;
    this.getPaymentBlocker(this.page);
  }
  Searchdata(event) {
    if (event) {
      this.page = 0;
      this.getPaymentBlocker(this.page);
    }
  }
}
